<script lang="ts">
import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import Chart from "chart.js";
import { Line } from "vue-chartjs";

/**
 * Chartjs Lineコンポーネント
 */
@Component
export default class LinesChart extends Mixins(Line) {
  /** グラフに表示する内容 */
  @Prop({
    default: () => {
      return {};
    }
  })
  chartData!: Chart.ChartData;

  /**
   * vue lifecycle created
   */
  public created(): void {
    return;
  }

  /**
   * vue lifecycle mounted
   */
  public mounted(): void {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      // ツールチップ
      tooltips: {
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "rgba(0, 0, 0, .2)",
        borderWidth: 1,
        titleFontColor: "rgba(0, 0, 0, 1)",
        titleFontSize: 14,
        bodyFontColor: "rgba(0, 0, 0, 1)",
        bodyFontSize: 14,
        bodySpacing: 8,
        xPadding: 8,
        yPadding: 12
      },
      scales: {
        yAxes: [
          // Ｙ軸
          {
            ticks: {
              // 目盛りの最小値
              min: 0
            }
          }
        ]
      }
    });

    return;
  }

  /**
   * propの値が更新されたらグラフを再描画する
   * chartjsのグラフ再描画を使用すると、高さがリセットされるようなので自前で行う
   */
  @Watch("chartData")
  public chartDataChanged(): void {
    this.renderChart(this.chartData, {
      responsive: true,
      maintainAspectRatio: false,
      // ツールチップ
      tooltips: {
        backgroundColor: "rgba(255, 255, 255, 1)",
        borderColor: "rgba(0, 0, 0, .2)",
        borderWidth: 1,
        titleFontColor: "rgba(0, 0, 0, 1)",
        titleFontSize: 14,
        bodyFontColor: "rgba(0, 0, 0, 1)",
        bodyFontSize: 14,
        bodySpacing: 8,
        xPadding: 8,
        yPadding: 12
      },
      scales: {
        yAxes: [
          // Ｙ軸
          {
            ticks: {
              // 目盛りの最小値
              min: 0
            }
          }
        ]
      }
    });

    return;
  }
}
</script>
